import Vue from 'vue'
import App from './App.vue'
import router from './router'

import * as api from './api'
import './assets/styles/style.css'
import {
  
  Popup,
  Overlay
} from 'vant'

Vue.use(Popup)
Vue.use(Overlay)

import 'vant/lib/popup/style';
import 'vant/lib/overlay/style';


Vue.prototype.$api = api
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
